// NEOGRIPX — Ver la foto de la ficha a pantalla completa (botón ⤢ de la galería)
// Agranda la propia caja de la galería, así el deslizador oscura/clara sigue
// funcionando. Flechas (o teclado / deslizar) pasan por las miniaturas visibles.
(function () {
  const main = document.querySelector('.product-gallery-main');
  const open = main && main.querySelector('[data-nxz-open]');
  if (!open) return;
  const close = main.querySelector('[data-nxz-close]');
  const prev = main.querySelector('[data-nxz-prev]');
  const next = main.querySelector('[data-nxz-next]');
  const backdrop = document.createElement('div');
  backdrop.className = 'nxz-backdrop';
  backdrop.hidden = true;
  main.parentNode.insertBefore(backdrop, main);

  const thumbs = () => Array.from(document.querySelectorAll('.product-thumb')).filter((t) => !t.classList.contains('thumb-hidden'));
  const go = (step) => {
    const list = thumbs();
    if (list.length < 2) return;
    const i = Math.max(0, list.findIndex((t) => t.classList.contains('active')));
    list[(i + step + list.length) % list.length].click();
  };

  // A pantalla completa, la foto a su tamaño máximo. Se cambia solo la imagen:
  // las miniaturas conservan su dirección porque el filtro por tipo de bici la usa.
  const img = document.getElementById('mainProductImg');
  const upgrade = () => {
    if (!img || !main.classList.contains('is-full')) return;
    const big = img.src.replace(/width=\d+/, 'width=2048');
    if (big !== img.src) img.src = big;
  };
  if (img) new MutationObserver(upgrade).observe(img, { attributes: true, attributeFilter: ['src'] });

  // La caja deja un hueco del mismo tamaño en la página para que nada salte
  const placeholder = document.createElement('div');
  const show = () => {
    placeholder.style.height = main.offsetHeight + 'px';
    main.after(placeholder);
    backdrop.hidden = false;
    main.classList.add('is-full');
    upgrade();
    main.dispatchEvent(new CustomEvent('nxz:open'));
    document.documentElement.classList.add('nxz-lock');
    const multi = thumbs().length > 1;
    prev.hidden = !multi;
    next.hidden = !multi;
    close.focus();
  };
  const hide = () => {
    main.classList.remove('is-full');
    backdrop.hidden = true;
    placeholder.remove();
    document.documentElement.classList.remove('nxz-lock');
    open.focus();
  };

  open.addEventListener('click', show);
  close.addEventListener('click', hide);
  backdrop.addEventListener('click', hide);
  prev.addEventListener('click', () => go(-1));
  next.addEventListener('click', () => go(1));
  document.addEventListener('keydown', (e) => {
    if (!main.classList.contains('is-full')) return;
    if (e.key === 'Escape') hide();
    if (e.key === 'ArrowLeft') go(-1);
    if (e.key === 'ArrowRight') go(1);
  });

  // Sin deslizador a la vista, pulsar la foto también la abre en grande
  main.addEventListener('click', (e) => {
    if (main.classList.contains('is-full')) return;
    const slider = main.querySelector('[data-nxc]');
    if (slider && !slider.hidden) return;
    if (e.target.closest('button, a, input')) return;
    show();
  });

  // En el móvil, deslizar el dedo sobre la foto (sin deslizador) pasa de foto
  let x0 = null;
  main.addEventListener('touchstart', (e) => {
    const slider = main.querySelector('[data-nxc]');
    x0 = main.classList.contains('is-full') && (!slider || slider.hidden) ? e.touches[0].clientX : null;
  }, { passive: true });
  main.addEventListener('touchend', (e) => {
    if (x0 === null) return;
    const dx = e.changedTouches[0].clientX - x0;
    if (Math.abs(dx) > 50) go(dx < 0 ? 1 : -1);
    x0 = null;
  });
})();
